interface Props {
  isMaintenanceTaskOpen: boolean;
  canEditMaintenanceTask: boolean;
}

export const canRemoveMaintenanceTaskPersonnelAssignmentExternalStaff = ({
  isMaintenanceTaskOpen,
  canEditMaintenanceTask,
}: Props): boolean => isMaintenanceTaskOpen && canEditMaintenanceTask;
